// extracted by mini-css-extract-plugin
export default {"categoriesList":"Tags-module-a941df363b8b9b61d862"};